import { Link } from 'react-router-dom'
import '../styles/notfound.css'

export default function NotFound() {
  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you're looking for doesn't exist.</p>
        <Link to="/dashboard" className="back-link">
          Go back to Dashboard
        </Link>
      </div>
    </div>
  )
}
